module.exports = __webpack_public_path__ + "img/img-shop-food-1.275b8209.png";